<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>应付应收</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      label-position="right"
      label-width="120px"
      class="searchBar"
    >
      <el-row>
        <el-form-item label="结账日期：">
          <el-date-picker
            size="small"
            v-model="formInline.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="结账日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="handleSearch"
            >搜索</el-button
          >
          <el-button
            size="small"
            type="info"
            icon="el-icon-delete"
            @click="handleReset"
            >清空</el-button
          >
          <el-button size="small" @click="handleExport" icon="el-icon-top-right"
            >导出</el-button
          >
        </el-form-item>
      </el-row>
    </el-form>
    <div
      style="
        width: 100%;
        text-align: right;
        margin-bottom: 10px;
        height: 50px;
        line-height: 50px;
      "
    >
      <span>
        应收总金额（万）<span style="font-weight: bold">{{
          intfaceValue
        }}</span>
      </span>
      <span>
        应付总金额（万）<span style="font-weight: bold">{{
          outfaceValue
        }}</span>
      </span>
    </div>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
      :cell-style="handleCellStyle"
    >
      <el-table-column align="center" label="操作" width="240">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.ticket.in.update"
            type="primary"
            @click="handleEdit(scope.row)"
            >应收应付</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="customerName"
        label="客户名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="date"
        label="日期"
        width="100px"
        show-overflow-tooltip
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="salesman"
        label="客户经理"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="faceValue"
        label="金额（万）"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="type"
        label="收付类型"
        :formatter="handleFormatType"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <Payment
      title="应收应付"
      :visible.sync="visiblePayment"
      :editForm="editData"
      @confirm="handlePayment"
    ></Payment>
  </div>
</template>

<script>
import { listBill, exportBill } from "@/api/ticket/ticket";
import Pagination from "@/components/pagination";
import Payment from "./payment";
import { formatMoney, timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

export default {
  filters: {
    handleFormatMoney(val) {
      if (val) {
        return formatMoney(val);
      }

      return val;
    },
  },
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      loading: false,
      userData: [],
      intfaceValue: 0,
      outfaceValue: 0,
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
      formInline: {},
      visiblePayment: false,
      editData: {},
    };
  },
  components: {
    Pagination,
    Payment,
  },
  created() {
    this.getData();
  },
  methods: {
    handleCellStyle({ row, column }) {
      // 收付类型 1 应收 2 应付 type
      if ("type" === column.property) {
        if (parseInt(row.type) === 1) {
          return { background: "#409EFF", color: "#fff" };
        } else if (parseInt(row.type) === 2) {
          return { background: "#67C23A", color: "#fff" };
        }
      }
      return null;
    },
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    handleFormatInStatus(row, column, cellValue) {
      // 入库出库 1 入库 2 出库
      if (cellValue === "1") {
        return "入库";
      } else if (cellValue === "2") {
        return "出库";
      } else {
        return "--";
      }
    },
    handleFormatType(row, column, cellValue) {
      // 收付类型 1 应收 2 应付   type
      if (cellValue === "1") {
        return "应收";
      } else if (cellValue === "2") {
        return "应付";
      } else {
        return "--";
      }
    },
    handleFormatMoney(row, column, cellValue) {
      if (cellValue) {
        return formatMoney(cellValue);
      }

      return cellValue;
    },
    handleExport() {
      exportBill()
        .then((data) => {
          let pathData = window.URL.createObjectURL(data);
          // for IE
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              pathData,
              `${timestampToDate(Date.now())}_应收应付.xls`
            );
          } else {
            let link = document.createElement("a");
            link.href = pathData; // 创建下载的链接
            link.download = `${timestampToDate(Date.now())}_应收应付.xls`; // 下载后文件名
            link.target = "_blank";
            link.style.display = "none";
            document.body.appendChild(link);
            link.click(); // 点击下载
            document.body.removeChild(link); // 下载完成移除元素
          }
        })
        .catch(this.$message.error);
    },
    getData() {
      this.loading = true;
      listBill(this.pager.currentPage, this.pager.pageSize, this.formInline)
        .then(
          ({
            intfaceValue,
            outfaceValue,
            list: { content, page, size, totalCount },
          }) => {
            this.intfaceValue = intfaceValue;
            this.outfaceValue = outfaceValue;
            this.userData = content;
            this.pager.currentPage = page;
            this.pager.pageSize = size;
            this.pager.total = totalCount;
          }
        )
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handlePayment() {
      this.getData();
    },
    handleEdit(row) {
      this.visiblePayment = true;
      this.editData = row;
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {};
      this.getData();
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/ticket-bill/index.vue